module.exports = __webpack_public_path__ + "videos/colordrop-cn.c49a1a9.mp4";